import React, { useState, useEffect, useRef } from "react";

const TextFilterInput = ({ placeholder, value, onFilterChange, debounceTime = 250, readOnly = false }) => {
   const debounceRef = useRef(null);

   useEffect(() => {
      if (debounceRef.current) {
         clearTimeout(debounceRef.current);
      }

      debounceRef.current = setTimeout(() => {
         onFilterChange(value); // Pass final value after debounce
      }, debounceTime);

      return () => clearTimeout(debounceRef.current);
   }, [value, onFilterChange, debounceTime]);

   return (
      <input
         type="text"
         placeholder={placeholder}
         className="form-control mt-2"
         value={value}
         onChange={(e) => onFilterChange(e.target.value)}
         onClick={(e) => e.stopPropagation()}
         onFocus={(e) => e.stopPropagation()}
         readOnly={readOnly}
      />
   );
};

export default TextFilterInput;
